export const Logo = ({ className = "" }) => (
  <span
    className={`inline-flex items-center justify-center rounded-2xl bg-navy px-4 py-2.5 shadow-lg shadow-navy/25 ring-1 ring-white/10 ${className}`}
  >
    <span className="font-display text-lg font-bold leading-none tracking-tight text-white">
      site<span className="text-gold">.</span>com
    </span>
  </span>
);
